import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import * as TourActions from './tour.actions';
import { TourLongDto, TourV11Service } from '@api/rest';

@Injectable()
export class TourEffects {
  private actions$ = inject(Actions);
  private tourHttp = inject(TourV11Service);


  loadTours$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TourActions.loadTours),
      switchMap(() => this.tourHttp.restV11TourGet(true, true)
        .pipe(
          map((tours: TourLongDto[]) => TourActions.loadToursSuccess({ tours })),
          catchError(error => of(TourActions.loadToursFailure({ error })))
        )
      )
    );
  });

  setSelected: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType('@ngrx/router-store/navigated'),
      map((action: any) => action.payload.event.url.split('/')),
      filter(routes => routes.includes('tour')),
      map(routes => routes[ routes.findIndex(route => route === 'tour') + 1 ]),
      map(id => TourActions.setSelectedTour({ id }))
    )
  );

  getTour$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(TourActions.getTour),
      switchMap(payload => this.tourHttp.restV11TourIdGet(payload.id)
        .pipe(
          map(tour => TourActions.getTourSuccess({ tour })),
          catchError(error => of(TourActions.getTourFailure({ error })))
        )
      )
    );
  });

}
